import { connect } from 'react-redux'
import * as favoritesActions from 'lib/api/favorites'
import { SegmentListItem } from 'common/ListItems'

const mapDispatchToProps = (dispatch) => ({
  unpin: (id) => dispatch(favoritesActions.unpin('segment', id))
})

const mapStateToProps = (state, ownProps) => {
  const favorites = state.favorites

  return {
    pinned: !!favorites.getIn(['favoritesByType', 'segment', ownProps.segment.get('id')])
  }
}

export const SegmentListItemContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SegmentListItem)
